<template>
  <div class="relative sm:mt-3">
    <form
      class="text-left"
      autocomplete="off"
    >
      <label class="text-left text-xxs font-bold uppercase text-dark-blue">
        {{ label }}
      </label>
      <label class="relative z-0">
        <input
          :id="id"
          v-model="search"
          type="text"
          class="relative mt-1 w-full rounded border border-transparent p-4 text-sm text-dark-gray hover:border-placeholder-gray focus:text-body-color"
          :class="
            show & (search.length > 0)
              ? 'rounded-b-md border border-body-color bg-white'
              : 'rounded-b bg-off-white'
          "
          :placeholder="placeholder"
          @input="handleInput"
        />
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="magnifying-glass"
        >
          <path
            d="M12.0195 12.7188L16.4995 17.1987"
            stroke="#6D7181"
            stroke-width="2"
          />
          <circle
            cx="8.17989"
            cy="8.23897"
            r="6.67989"
            stroke="#6D7181"
            stroke-width="2"
          />
        </svg>
      </label>
    </form>
    <div
      v-if="filtered.length > 0 && show && search.length > 0"
      class="filter-container absolute z-30 w-full rounded-md rounded-t-none border-b border-l border-r border-body-color bg-white pb-2"
    >
      <div
        v-for="item in filtered"
        :key="item"
      >
        <div
          class="flex pb-2 pl-4 pr-4 pt-2"
          @click="handleClick(item)"
        >
          <div
            v-if="item.name"
            class="flex w-full justify-between"
          >
            <p class="text-gray-over-dark">
              {{ item.name }}
            </p>
            <p class="flex flex-col justify-end text-3xs text-gray-over-dark">
              {{
                item.mailing_address_city + ', ' + item.mailing_address_state
              }}
            </p>
          </div>
        </div>
      </div>
      <div @click="closeFilter">
        <slot />
      </div>
    </div>
    <div v-else>
      <div
        v-if="search.length > 0 && show"
        class="filter-container absolute z-30 w-full rounded-md rounded-t-none border-b border-l border-r border-body-color bg-white pb-2"
        @click="closeEmptyFilter"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutocompleteSearch',
  props: {
    data: Object,
    type: {
      type: String,
      default: '',
    },
    toggleButton: {
      type: Function,
      default: () => {},
    },
    items: Array,
    label: String,
    field: {
      type: String,
      default: '',
    },
    objectField: {
      type: String,
      default: '',
    },
    placeholder: String,
    handleSelect: {
      type: Function,
      default: () => {},
    },
    id: String,
    handleOnChange: {
      Type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
      search: '',
    };
  },
  computed: {
    filtered: function () {
      if (!this.$props.items.length) return [];
      let filteredArray = this.$props.items.filter((el) => {
        return el.name.toLowerCase().includes(this.search.toLowerCase());
      });
      return filteredArray;
    },
  },
  methods: {
    handleClick(item) {
      this.show = false;
      this.search =
        this.$props.type === 'address'
          ? Object.values(item.address).join(', ')
          : item.name;
      this.handleSelect(item);
    },
    handleInput() {
      this.handleOnChange(this.search);
      this.show = true;
      if (!this.search.length) this.toggleButton(true);
    },
    closeFilter() {
      this.show = false;
    },
    closeEmptyFilter() {
      this.show = true;
    },
  },
};
</script>

<style scoped>
input:focus {
  outline: none;
  @apply border border-body-color bg-white;
}
input:focus + .magnifying-glass > path,
input:focus + .magnifying-glass > circle {
  stroke: #313545;
}
.filter-container {
  top: 78px;
  cursor: pointer;
}
.magnifying-glass {
  position: absolute;
  top: 2px;
  right: 17px;
}
</style>
